




















































































































































import { Component, Vue } from "vue-property-decorator";
import QuickSnack from "@/components/QuickSnack.vue";
import { Company, UserQueryFilter, User, VueRoot, domain, Certificate } from "@/domain";
import DatePicker from "@/components/DatePicker.vue";
import * as util from "@/util";
import { RawTransaction } from "@/domain/types/transactions_query";
import { jsPDF } from "jspdf";
import autoTable, { Table } from "jspdf-autotable";
import moment from "moment";
import { EuroshellCertificateResult } from "@/domain/backend";

interface jsPDFAutoTable extends jsPDF {
  lastAutoTable?: Table;
}

@Component({
  components: { QuickSnack, DatePicker }
})
export default class EuroshellCertificate extends Vue {
  isLoading = true;
  savingData = false;
  dialog = false;
  // Table properties
  filters?: UserQueryFilter = {
    queryAll: false
  };
  txtFromDate = util.isoDateString();
  txtToDate = util.isoDateString();
  certificates = [] as Certificate[];
  certificateSearch = "";

  newCertificate: Certificate = {
    date: util.isoDateString(),
    cardNumber: "",
    from: util.isoDateString(),
    to: util.isoDateString(),
    page: 0,
    saved: false
  };

  get lang() {
    return this.$store.state.lang.data;
  }

  get currentCompany(): Company | null {
    if (this.$store.state.selectedCompanyLoading) {
      return null;
    }
    return this.$store.state.selectedCompany;
  }

  get currentUser(): User {
    return this.$store.state.currentUser || {};
  }

  get isMobile(): boolean {
    return (this.$root as VueRoot).isMobile;
  }
  get disableProcessBtn(): boolean {
    return false;
  }

  get validateForm() {
    if (this.newCertificate.cardNumber.length < 14) return true;
    return false;
  }

  onDialogMessage(content: { message: string; color: string }) {
    this.snack.show(content.message, content.color);
  }

  isNumberOrAsterisk(rawEvt: unknown) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const evt = rawEvt ? (rawEvt as any) : window.event;
    const charCode = evt.which ? evt.which : evt.keyCode;
    if (evt.target.value.length > 19) return evt.preventDefault();
    if (charCode === 42 && evt.target.value.length < 14) return evt.preventDefault();
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46 && charCode !== 42) {
      return evt.preventDefault();
    } else {
      return true;
    }
  }

  formatNumber(vaule: number) {
    const numberFormatter = Intl.NumberFormat("de-DE", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 2
    });
    const formatted = numberFormatter.format(vaule);
    return formatted;
  }

  //Rules
  get dateRules() {
    return [util.rules.required(this.lang.ruleValueRequired)];
  }

  get requiredRules() {
    return [util.rules.required(this.lang.ruleRequiredField)];
  }

  created() {
    this.$nextTick(() => {
      this.refreshCertificates();
    });
  }

  get snack(): QuickSnack {
    return this.$refs.snack as QuickSnack;
  }

  async refreshCertificates() {
    try {
      this.isLoading = true;
      const savedResult = await domain.backend.getEuroshellCertificateList(this.txtFromDate, this.txtToDate);
      savedResult.certificates.sort((a, b) => (b.created || 0) - (a.created || 0));
      this.isLoading = false;
      this.certificates = savedResult.certificates;
    } catch (error) {
      this.onDialogMessage({ message: "No se pudo cargar los certificados", color: "red" });
      this.isLoading = false;
    }
  }

  async cmdProcess(data: null | Certificate = null) {
    try {
      this.savingData = true;
      let body = this.newCertificate;
      if (data) body = data;
      if (body) {
        const savedResult = await domain.backend.saveEuroshellCertificate(body);
        this.createPDF(body, savedResult);
        this.savingData = false;
        this.dialog = false;
        this.refreshCertificates();
      }
    } catch (error) {
      this.onDialogMessage({
        message: (error as { userMessage: string }).userMessage || "Hubo un error al crear el Certificado",
        color: "red"
      });
      this.savingData = false;
      this.refreshCertificates();
    }
  }

  get tableHeaders() {
    const headers: { text?: string; value: string; align: string; sortable?: boolean }[] = [];
    headers.push({
      text: this.lang.date,
      align: "left",
      value: "date"
    });
    headers.push({
      text: this.lang.card,
      align: "left",
      value: "cardNumber"
    });
    headers.push({
      text: this.lang.from,
      align: "center",
      value: "from"
    });
    headers.push({
      text: this.lang.to,
      align: "left",
      value: "to"
    });
    headers.push({
      text: this.lang.download,
      value: "actions",
      align: "center",
      sortable: false
    });
    return headers;
  }

  getCardNumber(card: string) {
    return card.slice(0, 6) + "*****" + card.slice(11, 20);
  }

  getFormatedDate(timestamp: { day: number; month: number; year: number } | null) {
    if (timestamp === null) return "";
    return timestamp.day + "-" + timestamp.month + "-" + timestamp.year;
  }

  createPDF(query: Certificate, data: EuroshellCertificateResult) {
    moment.locale("es");
    const txn = data.txns.transactions.filter(
      (e) =>
        e.type === "sale" ||
        e.type === "saleAC" ||
        e.type === "refund" ||
        e.type === "refundAC" ||
        e.type === "authClose"
    );

    if (!txn.length)
      return this.onDialogMessage({
        message: "La tarjeta no tiene transacciones en la fecha seleccionada.",
        color: "info"
      });
    // const card = this.getCardNumber(data.txns.transactions[0]?.hiddenCardNumber || "");
    const card = this.getCardNumber(query.cardNumber);
    const from = query.from.split("-")[2] + "-" + query.from.split("-")[1] + "-" + query.from.split("-")[0];
    const to = query.to.split("-")[2] + "-" + query.to.split("-")[1] + "-" + query.to.split("-")[0];
    const date = moment(query.date).format("LL");
    const height = 45;

    let doc = new jsPDF();
    doc.setFont("helvetica");

    // ADD TEMPLATE TO FIRST PAGE
    const img = new Image();
    img.src = require("@/assets/pdf-watermark.png");
    doc.addImage(img, "png", 0, 0, doc.internal.pageSize.getWidth(), doc.internal.pageSize.getHeight());

    // Titulo
    doc.setFontSize(20);
    doc.text("Certificado Transacciones", 200, height, {
      renderingMode: "fill",
      align: "right"
    });
    // Fecha
    doc.setFontSize(10);
    doc.text(date, 200, height + 10, {
      align: "right"
    });
    // Texto
    doc.setFontSize(13);
    doc.text("PAYTEF S.L. con NIF: B86145505 domiciliado en Paseo del Club Deportivo 1, Edif. 4 1ª", 10, height + 20, {
      align: "justify"
    });
    doc.text(
      "Planta (28223) Pozuelo de Alarcón, Madrid, y en su nombre y representación Arturo Castillo",
      10,
      height + 25,
      { align: "justify" }
    );
    doc.text("García con DNI: 53567666E, en su condición de administrador de sistemas.", 10, height + 30, {
      align: "justify"
    });
    doc.text("Hace constar", 100, height + 40, { align: "center", baseline: "middle" });
    doc.text(
      "Que, a petición de su cliente Disa, los datos que figuran en nuestros archivos, referentes a",
      10,
      height + 53,
      { align: "justify" }
    );
    doc.text(`los suministros efectuados en el período del ${from} al ${to} con la tarjeta`, 10, height + 58, {
      align: "justify"
    });
    doc.text(`${card}, son los siguientes:`, 10, height + 63, { align: "justify" });

    // DATA TABLE
    const rowsPerPage = 15;
    const pages = Math.ceil(txn.length / rowsPerPage);
    let currentPage = 0;
    while (currentPage < pages) {
      const txns = new Array<RawTransaction>();
      const start = currentPage * rowsPerPage;
      const finish = start + rowsPerPage;
      txn.forEach((t, i: number) => {
        if (i >= start && i < finish) txns.push(t);
      });
      doc = this.addTable(doc, txns, currentPage);
      if (currentPage + 1 !== pages) {
        doc.addPage();
        doc.addImage(img, "png", 0, 0, doc.internal.pageSize.getWidth(), doc.internal.pageSize.getHeight());
      }
      currentPage++;
    }
    const finalY = (doc as jsPDFAutoTable).lastAutoTable?.finalY || 0;

    // FIRMA
    doc.text("Atentamente,", 10, finalY + 20, { align: "justify" });
    doc.text("Arturo Castillo García", 10, finalY + 30, { align: "justify" });

    const img2 = new Image();
    img2.src = require("@/assets/DISA-Signature.png");
    img2.onload = () => {
      doc.addImage(img2, "png", 10, finalY + 35, 40, 15);
      doc.save("Certificado Euroshell.pdf");
    };
  }

  addTable(doc: jsPDF, txn: RawTransaction[], page: number): jsPDF {
    const body: { date: string; id: string; name: string; amount: string }[] = [];
    txn.forEach((e) => {
      body.push({
        date: this.getFormatedDate(e.timestamp),
        id: (e.id || "").toString(),
        name: (e.branchName || "").toString(),
        amount: this.formatNumber(Number(e.amountWithSign))
      });
    });
    autoTable(doc, {
      theme: "grid",
      startY: page === 0 ? 120 : 45,
      tableLineColor: [0, 0, 0],
      headStyles: {
        cellPadding: 1,
        fillColor: "#FFF",
        textColor: 0,
        halign: "center"
      },
      pageBreak: "auto",
      columnStyles: {
        date: { halign: "center" },
        id: { halign: "center" },
        name: { halign: "center" },
        amount: { halign: "right" }
      },
      bodyStyles: { lineColor: [0, 0, 0], cellPadding: 1 },
      head: [{ date: "Fecha", id: "N.° operación", name: "E.S", amount: "Importe" }],
      body: body
    });
    return doc;
  }
}
